/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_jw_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free online JWT decoder. Paste a JSON Web Token to view its header and payload as formatted JSON, with exp/iat/nbf shown as UTC dates. Decode only, in your browser — no signature verification.`)
};

const es_jw_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Decodificador JWT en línea gratuito. Pega un JSON Web Token para ver su encabezado y carga útil como JSON formateado, con exp/iat/nbf mostrado como fechas UTC. Solo decodifica, en tu navegador, sin verificación de firma.`)
};

const de_jw_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloser Online-JWT-Decoder. Fügen Sie ein JSON Web Token ein, um Header und Payload als formatiertes JSON anzuzeigen — exp/iat/nbf werden als UTC-Daten dargestellt. Nur Dekodierung, direkt in Ihrem Browser — keine Signaturprüfung.`)
};

const nl_jw_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis online JWT-decoder. Plak een JSON Web Token in om de header en payload als opgemaakte JSON te bekijken, met exp/iat/nbf weergegeven als UTC-datums. Alleen decoderen, in uw browser — geen handtekeningverificatie.`)
};

const fr_jw_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Décodeur JWT en ligne gratuit. Collez un jeton JWT pour afficher son en-tête et sa charge utile au format JSON, avec exp/iat/nbf affichés sous forme de dates UTC. Décodage uniquement, dans votre navigateur — pas de vérification de signature.`)
};

const it_jw_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Decodificatore JWT online gratuito. Incolla un JSON Web Token per visualizzare la sua intestazione e payload come JSON formattato, con exp/iat/nbf mostrati come date UTC. Solo decodifica, nel tuo browser - nessuna verifica della firma.`)
};

const pt_br2_jw_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Decodificador JWT online gratuito. Cole um JSON Web Token para visualizar seu cabeçalho e payload como JSON formatado, com exp/iat/nbf mostrados como datas UTC. Apenas decodificação, no seu navegador — sem verificação de assinatura.`)
};

const pt_jw_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descodificador JWT online gratuito. Cole um JSON Web Token para ver o seu cabeçalho e carga como JSON formatado, com exp/iat/nbf apresentados como datas UTC. Apenas descodificação, no seu navegador — sem verificação de assinatura.`)
};

const ja_jw_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料のオンラインJWTデコーダー。JSON Web Tokenを貼り付けてヘッダーとペイロードをフォーマットされたJSONとして表示し、exp/iat/nbfをUTC日付として表示します。デコードのみ、ブラウザで実行 — シグネチャ検証はありません。`)
};

const zh_jw_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费的在线 JWT 解码器。粘贴一个 JSON Web Token，即可以格式化的 JSON 形式查看其头部和载荷，exp/iat/nbf 会以 UTC 日期显示。仅在你的浏览器中解码——不验证签名。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const jw_meta_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.jw_meta_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("jw_meta_description", locale)
	if (locale === "en") return en_jw_meta_description(inputs)
	if (locale === "es") return es_jw_meta_description(inputs)
	if (locale === "de") return de_jw_meta_description(inputs)
	if (locale === "nl") return nl_jw_meta_description(inputs)
	if (locale === "fr") return fr_jw_meta_description(inputs)
	if (locale === "it") return it_jw_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_jw_meta_description(inputs)
	if (locale === "pt") return pt_jw_meta_description(inputs)
	if (locale === "ja") return ja_jw_meta_description(inputs)
	return zh_jw_meta_description(inputs)
};